<template>
  <div :class="['home flex-column', programStyle]">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('dealer-list') }}</span>
        <div class="subtitle flex-row">
          <div class="breadcrumb" @click="goToPrograms">{{ $t('programs') }} <span> > </span></div>
          <div>{{ programName }}</div>
        </div>
      </div>
      <div class="right">
        <FilterModal
          :appliedFiltersLength="appliedFilters.length"
          :valueMulti="activeFilters"
          @clear-filters="clearAllFilters"
          @updateMulti="updateMulti"
        />
        <div>
          <Magnifier class="search-icn"></Magnifier>
          <input class="search-input" :placeholder="$t('search')" v-model="searchQuery" type="search" />
        </div>
      </div>
    </div>
    <div v-if="programName && entities" class="flex-column">
      <div class="flex-column">
        <DataTable :headings="dealerListTH" :rows="filteredAssets" :perPage="rowCount" :page="currentPage">
          <template v-slot:actionSlot="slotProps">
            <Eyecon class="eyecon" @click="view(slotProps)"></Eyecon>
          </template>
        </DataTable>
        <div class="row-container" v-if="filteredAssets.length > 0">
          <div class="row-info">
            {{ $t('viewing-firstrow-lastrow-of-filteredassets-length', [firstRow, lastRow, filteredAssets.length]) }}
          </div>
          <BasePagination
            :current-page="currentPage"
            :page-count="pageCount"
            class="articles-list__pagination"
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            @loadPage="pageChangeHandle"
          />
          <div class="placeholder-div"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Eyecon from '@/assets/new/eye-con.svg';
import BasePagination from '@/components/BasePagination.vue';
import Magnifier from '@/assets/icons/magnifier.svg';
import FilterModal from '@/components/FilterModal.vue';
import dealerListTH from '@/utils/tableHeaders/dealerListTH';
import { mapState } from 'vuex';

const filterOptions = {};

export default {
  name: 'DealerList',
  components: {
    DataTable,
    Eyecon,
    BasePagination,
    Magnifier,
    FilterModal,
  },
  data() {
    return {
      rowCount: 10,
      searchQuery: '',
      currentPage: 1,
      rowCountDropValue: { label: this.$t('show-10'), value: 10 },
      firstRow: 1,
      lastRow: 10,
      filterOptions,
      entities: null,
      bcFilterOptions: null,
      uniqueBusinessCenter: [],
      uniqueSalesDistrict: [],
      uniqueServiceDistrict: [],
      uniqueSalesGroup: [],
      multiFilterOptions: {},
      dealerListTH: dealerListTH(),
    };
  },
  methods: {
    view(slotProps) {
      const domain = this.programName;
      this.$store.state.activeItem = 'Dashboard';
      this.$router.push({
        name: 'Dealer',
        params: { domain, entity: slotProps.row.entity },
      });
    },
    async pageChangeHandle(value) {
      switch (value) {
        case 'next':
          this.currentPage += 1;
          break;
        case 'previous':
          this.currentPage -= 1;
          break;
        default:
          this.currentPage = value;
      }
      this.calcFirstAndLastRow();
    },
    calcFirstAndLastRow() {
      this.firstRow = 1 + (this.currentPage - 1) * 10;
      if (this.filteredAssets.length < 10) {
        this.lastRow = this.filteredAssets.length;
      } else {
        this.lastRow = this.firstRow + 9;
      }
      if (this.lastRow > this.filteredAssets.length) {
        this.lastRow = this.filteredAssets.length;
      }
    },
    clearAllFilters() {
      if (this.multiFilterOptions.BC) {
        this.multiFilterOptions.BC.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.SalesDistrict) {
        this.multiFilterOptions.SalesDistrict.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.SalesGroup) {
        this.multiFilterOptions.SalesGroup.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      if (this.multiFilterOptions.ServiceDistrict) {
        this.multiFilterOptions.ServiceDistrict.forEach((tag) => {
          this.$set(tag, 'checked', false);
        });
      }
      this.$store.state.activeFilters = this.multiFilterOptions;
    },
    updateMulti(updates) {
      this.currentPage = 1;
      this.multiFilterOptions = updates;
      this.$store.state.activeFilters = this.multiFilterOptions;
    },
    updateCountry(country) {
      this.$store.state.global.programName = country.domain;
      this.getEntityData(this.programName);
    },
    getEntityData() {
      const loader = this.$loading.show();
      const domain = this.programName;
      this.$store.dispatch('getDomainEntities', { domain }).then((res) => {
        this.entities = res;
        this.calcFirstAndLastRow();
        this.createFilters();
        loader.hide();
      });
    },
    goToPrograms() {
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$store.state.global.programStyle = null;
      this.$router.push({
        name: 'Programs',
      });
      // eslint-disable-next-line prefer-destructuring
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    onlyUnique(array) {
      const result = [...new Map(array.map((item) => [item.label, item])).values()];
      return result;
    },
    compareStrings(a, b) {
      if (a && b) {
        const a1 = a.toLowerCase();
        const b1 = b.toLowerCase();
        // eslint-disable-next-line no-nested-ternary
        return a1 < b1 ? -1 : a1 > b1 ? 1 : 0;
      }
      return 0;
    },
    sortAlphabetical(array) {
      array.sort((a, b) => this.compareStrings(a.label, b.label));
    },
    createFilters() {
      if (this.entities && !this.$store.state.activeFilters) {
        for (let i = 0; i < this.entities.length; i += 1) {
          this.uniqueBusinessCenter.push({
            label: this.entities[i].businessCenterAbbreviation,
            checked: false,
          });
          this.uniqueSalesDistrict.push({
            label: this.entities[i].salesDistrict,
            checked: false,
          });
          this.uniqueServiceDistrict.push({
            label: this.entities[i].serviceDistrict,
            checked: false,
          });
          this.uniqueSalesGroup.push({
            label: this.entities[i].groupSize,
            checked: false,
          });
        }
        this.multiFilterOptions = {
          BC: this.onlyUnique(this.uniqueBusinessCenter),
          SalesDistrict: this.onlyUnique(this.uniqueSalesDistrict),
          SalesGroup: this.onlyUnique(this.uniqueSalesGroup),
          ServiceDistrict: this.onlyUnique(this.uniqueServiceDistrict),
        };
        this.sortAlphabetical(this.multiFilterOptions.BC);
        this.sortAlphabetical(this.multiFilterOptions.SalesDistrict);
        this.sortAlphabetical(this.multiFilterOptions.SalesGroup);
        this.sortAlphabetical(this.multiFilterOptions.ServiceDistrict);

        this.$store.state.activeFilters = this.multiFilterOptions;
      }
    },
  },
  computed: {
    ...mapState('global', ['programStyle', 'programName']),
    ...mapState(['activeFilters', 'activeNavBar']),
    pageCount() {
      const l = this.filteredAssets.length;
      const s = this.rowCountDropValue.value;
      return Math.ceil(l / s);
    },
    appliedFilters() {
      const BCOptions = [];
      const SalesDistrictOptions = [];
      const ServiceDistricOptions = [];
      const SalesGroupOptions = [];
      let length = 0;
      if (this.activeFilters) {
        if (this.activeFilters.BC) {
          this.activeFilters.BC.forEach((option) => {
            if (option.checked) BCOptions.push(option);
          });
        }
        if (this.activeFilters.SalesDistrict) {
          this.activeFilters.SalesDistrict.forEach((option) => {
            if (option.checked) SalesDistrictOptions.push(option);
          });
        }
        if (this.activeFilters.SalesGroup) {
          this.activeFilters.SalesGroup.forEach((option) => {
            if (option.checked) SalesGroupOptions.push(option);
          });
        }
        if (this.activeFilters.ServiceDistrict) {
          this.activeFilters.ServiceDistrict.forEach((option) => {
            if (option.checked) ServiceDistricOptions.push(option);
          });
        }
      }
      length = BCOptions.length + SalesDistrictOptions.length + SalesGroupOptions.length + ServiceDistricOptions.length;
      return { BCOptions, length, SalesDistrictOptions, SalesGroupOptions, ServiceDistricOptions };
    },
    filteredAssets() {
      if (this.entities) {
        let newArray = [];

        newArray = this.entities.filter((item) => {
          let bcCheck = !this.appliedFilters.BCOptions.length;
          this.appliedFilters.BCOptions.forEach((filter) => {
            if (item.businessCenterAbbreviation === filter.label) {
              bcCheck = true;
            }
          });

          let salesDistrictCheck = !this.appliedFilters.SalesDistrictOptions.length;
          this.appliedFilters.SalesDistrictOptions.forEach((filter) => {
            if (item.salesDistrict === filter.label) {
              salesDistrictCheck = true;
            }
          });

          let salesGroupCheck = !this.appliedFilters.SalesGroupOptions.length;
          this.appliedFilters.SalesGroupOptions.forEach((filter) => {
            if (item.groupSize === filter.label) {
              salesGroupCheck = true;
            }
          });

          let serviceDistrictCheck = !this.appliedFilters.ServiceDistricOptions.length;
          this.appliedFilters.ServiceDistricOptions.forEach((filter) => {
            if (item.serviceDistrict === filter.label) {
              serviceDistrictCheck = true;
            }
          });

          let foundSearch = true;
          if (this.searchQuery) {
            const query = this.searchQuery.toLowerCase();
            foundSearch =
              (item.entity && item.entity.toLowerCase().indexOf(query) > -1) ||
              (item.dealerName && item.dealerName.toLowerCase().indexOf(query) > -1);
          }

          return foundSearch && bcCheck && salesDistrictCheck && salesGroupCheck && serviceDistrictCheck;
        });
        return newArray;
      }
      return null;
    },
  },
  created() {
    if (this.programName) {
      this.getEntityData();
    } else {
      this.$router.push({
        name: 'Programs',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    .breadcrumb {
      margin-right: 5px;
      cursor: pointer;
    }
  }
}

.logo {
  vertical-align: middle;
  width: 400px;
  margin-top: 35px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}

input {
  width: 300px;
}

::placeholder {
  color: black;
  opacity: 1;
}
.placeholder-div {
  width: 130px;
}
.empty-program {
  margin-top: 20px;
}
</style>
